import _find from 'lodash/find';
import React, { Component } from 'react';
import { Mutation, Query } from '@apollo/react-components';
import { inflateContent } from '@achievable-me/tundra-wizard/contentHelpers';
import SpinnerError from '$components/library/SpinnerError';
import { TOGGLE_SIDEBAR_EXPANDED } from '$queries/chrome';
import PRODUCT from '$queries/product';
import Track from '$components/layout/ProductLayout/Track';
import Sidenav from '$components/layout/ProductLayout/Sidenav';
import storage from '$lib/storage';
import styles from './styles.scss';

const getMenuOpenKeys = ({ content, location }) => {
  const { pathname } = location;

  if (/content|learn/.test(pathname)) {
    const matches = /(?:content|learn)\/(.*?)$/.exec(pathname);

    const childUuid = matches[1];
    const childContent = _find(
      content,
      (obj) => obj.uuid === childUuid || obj.slug === childUuid
    );

    if (!childContent) {
      return [];
    }

    const childKey = `content-${childUuid}`;
    const { parentUuid } = childContent;

    if (!parentUuid) {
      return ['content', childKey];
    }

    const parentKey = `content-${parentUuid}`;
    return ['content', parentKey, childKey];
  }

  return [];
};

class ProductLayout extends Component {
  constructor(props) {
    super(props);

    const { match } = props;
    const { params } = match;
    const { productSlug } = params;
    storage.lastProductSlug.set(productSlug);
  }

  render() {
    const { children, currentUser, location, match } = this.props;
    const { params } = match;
    const { productSlug } = params;

    return (
      <Query query={PRODUCT} variables={{ input: { slug: productSlug } }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const {
            product: { product },
          } = data;
          const { content } = product;

          const { flatContent, inflatedContent } = inflateContent({ product, content });
          const menuOpenKeys = getMenuOpenKeys({ content, location });

          return (
            <div className={styles.layout}>
              <Track currentUser={currentUser} />
              <Mutation mutation={TOGGLE_SIDEBAR_EXPANDED}>
                {(toggleSidebarExpanded) => (
                  <>
                    <Sidenav
                      currentUser={currentUser}
                      content={content}
                      inflatedContent={inflatedContent}
                      defaultOpenKeys={menuOpenKeys}
                      product={product}
                      toggleSidebarExpanded={toggleSidebarExpanded}
                      location={location}
                      match={match}
                      mode="user"
                    />
                    <div data-aaa="productLayoutContent" className={styles.content}>
                      <div
                        data-aaa="navBars"
                        className={styles.bars}
                        onClick={toggleSidebarExpanded}
                      >
                        <i className="fas fa-bars" />
                      </div>
                      {children({ flatContent, product, inflatedContent })}
                    </div>
                  </>
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default ProductLayout;
